export class Colors {
  static primaryLight = "#2f8bcc";
  static secondaryLight = "#d13e56";

  static primaryDark = "#ff9800";
  static secondaryDark = "#9c27b0";

  static dangerWhite = "#F9E5E5";

  static backgroundLight = "#f1f1f1";
  static backgroundDark = "#121212";
}
